import { CRMAPIBase } from '@api/crmApiBase'
import { RequestResult } from '@api/responseModels/requestResult'
import { TModelFields, TExportFields, TImportFields } from 'types/importExportFields'

type TModelFieldsResp = {
    [key: string]: string
}

class ImportExportGroup extends CRMAPIBase {
    async modelFields({ crm_id, model }: TModelFields): Promise<RequestResult<TModelFieldsResp>> { 
        const result = await this.get<any>(`/fields`, {crm_id, entity: model})
        return result
    }

    /**
     * Экспорт документа
     * @param crm_id ID CRM
     * @param model Модель
     * @param format Формат
     * @param selectedFields Массив идентификаторов выбранных полей
     * @returns Результат запроса
     */
    async exportDocument({crm_id, model, format, selectedFields}: TExportFields): Promise<RequestResult<any>> {
        const result = await this.get<any>(`/${model}/export`, {
            crm_id,
            format,
            storageOption: 'external',
            fields: selectedFields,
        })
        return result
    }

    /**
     * Импорт документа
     * @param crm_id ID CRM
     * @param model Модель
     * @param format Формат
     * @param file Файл
     * @param options Опции
     * @returns Результат запроса
     */
    async importDocument({ crm_id, model, format, file, options }: TImportFields): Promise<RequestResult<any>> {
        const formdata = new FormData()

        formdata.append('crm_id', crm_id.toString())
        formdata.append('format', format)
        formdata.append('file', file)
        formdata.append('options', JSON.stringify(options))
 
        const result = await this.post<any>(`/${model}/import`, formdata)
        return result
    }
}

export { ImportExportGroup }
